import axiosInstance from "../Instance";
import {
    REWARDS_STATS,
    REWARDS_CAMPAIGNS,
    REWARDS_ADD_OFFERS,
    REWARDS_ADD_OWN_PRIZE,
    REWARDS_OFFERS,
    REWARDS_EDIT_OFFER,
    REWARDS_SYNC_OFFERS,
    REWARDS_DELETE_OFFER,
    REWARDS_ISSUED_COUPONS,
    REWARDS_VOID_COUPON,
    REWARDS_RETRY_COUPON,
    REWARDS_RULE_EVENTS,
    REWARDS_RULES,
    REWARDS_ADD_RULE,
    REWARDS_EDIT_RULE,
    REWARDS_DELETE_RULE,
    REWARDS_SCRATCH_CARDS,
    REFERRALS_ADMIN,
    BILLPAY_CHARGE_RULES,
    BILLPAY_ADD_CHARGE_RULE,
    BILLPAY_EDIT_CHARGE_RULE,
    BILLPAY_ACTIVE_CHARGE_RULE,
    BILLPAY_DELETE_CHARGE_RULE,
    BILLPAY_CHARGE_PREVIEW,
    BILLPAY_SETTINGS,
    BILLPAY_EDIT_SETTINGS,
    BILLPAY_KWIK_BALANCE,
    BILLPAY_ORDERS,
    BILLPAY_ORDER,
    BILLPAY_RETRY_REFUND,
    BILLPAY_COMPLETE_REVIEW,
    BILLPAY_SEND_INVOICE,
    BILLPAY_STATS,
    BILLPAY_INVOICES,
    BILLPAY_INVOICE_SUMMARY,
    BILLPAY_DOWNLOAD_INVOICE,
    BILLPAY_EXPORT_INVOICES,
    VOUCHER_OFFERS,
    VOUCHER_EDIT_OFFER,
    MESSAGING_SETTINGS,
    MESSAGING_EDIT_SETTINGS,
    MESSAGING_ROUTING,
    MESSAGING_EDIT_ROUTING,
    MESSAGING_SMS_TEMPLATES,
    MESSAGING_EDIT_SMS_TEMPLATE,
    MESSAGING_WHATSAPP_TEMPLATES,
    MESSAGING_SYNC_WHATSAPP_TEMPLATES,
    MESSAGING_CHECK_WHATSAPP,
    MESSAGING_EDIT_WHATSAPP_BANNER,
    MESSAGING_SEND_TEST,
    MESSAGING_MESSAGE_LOG,
    MESSAGING_INBOX_SUMMARY,
    MESSAGING_CONVERSATIONS,
    MESSAGING_CONVERSATION,
    MESSAGING_SEND_REPLY,
    MESSAGING_EDIT_CONVERSATION,
    MESSAGING_INBOX_MEDIA,
    MESSAGING_CAMPAIGN_TEMPLATES,
    MESSAGING_PREVIEW_CAMPAIGN,
    MESSAGING_TEST_CAMPAIGN,
    MESSAGING_CREATE_CAMPAIGN,
    MESSAGING_CAMPAIGNS,
    MESSAGING_CAMPAIGN,
    MESSAGING_STOP_CAMPAIGN,
    GET_BRANDS,
    ADD_BRANDS,
    DELETE_BRANDS,
    ACTIVE_BRANDS,
    GET_CATEGORY,
    ADD_CATEGORY,
    DELETE_CATEGORY,
    ACTIVE_CATEGORY,
    GET_SUBCATEGORY,
    ADD_SUBCATEGORY,
    DELETE_SUBCATEGORY,
    ACTIVE_SUBCATEGORY,
    GET_PRODUCTS,
    GET_PRODUCT_BY_ID,
    ADD_PRODUCTS,
    DELETE_PRODUCTS,
    ACTIVE_PRODUCTS,
    UPDATE_PRODUCT_PRICE,
    UPDATE_ADDITIONAL_INFO_PRODUCT,
    UPDATE_INFO_PRODUCT,
    UPDATE_PRODUCT_DETAILS,
    UPDATE_PRODUCT_DOC,
    UPDATE_PRODUCT_ADDITION_DETAILS,
    GET_SPEND_TRACKER,
    ADD_SPEND_TRACKER,
    ADD_FAQ_SECTION,
    ADD_VIDEO_INSIGHT,
    GET_BANNERS,
    ADD_BANNER,
    DELETE_BANNER,
    ACTIVE_BANNER,
    GET_COUPON,
    ADD_COUPON,
    DELETE_COUPON,
    ACTIVE_COUPON,
    GET_CUSTOM_GOAL,
    ADD_CUSTOM_GOAL,
    EDIT_CUSTOM_GOAL,
    ACTIVE_CUSTOM_GOAL,
    DELETE_CUSTOM_GOAL,
    GET_GOAL_CATEGORY,
    ADD_GOAL_CATEGORY,
    DELETE_GOAL_CATEGORY,
    ACTIVE_GOAL_CATEGORY,
    UPDATE_BOARDING,
    UPDATE_SUBCATEGORY,
    DELETE_FAQ_SECTION,
    EDIT_FAQ_SECTION,
    GET_FAQ_SECTION,
    ACTIVE_FAQ_SECTION,
    GET_VIDEO_INSIGHT,
    ACTIVE_VIDEO_INSIGHT,
    DELETE_VIDEO_INSIGHT,
    EDIT_VIDEO_INSIGHT,
    EDIT_BRANDS,
    EDIT_CATEGORY,
    ACTIVE_SPEND_TRACKER,
    DELETE_SPEND_TRACKER,
    UPDATE_SPEND_TRACKER,
    EDIT_GOAL_CATEGORY,
    EDIT_BANNER,
    EDIT_COUPON,
    GET_BOARDING,
    DELETE_BOARDING,
    ACTIVE_BOARDING,
    EDIT_BOARDING,
    GET_ADMINS,
    UPDATE_ADMIN,
    DELETE_ADMIN,
    ADMIN_PROFILE,
    GET_USERS,
    GET_USER_ACTIVITY,
    GET_ACCOUNT_DELETION_REQUESTS,
    GET_ACCOUNT_DELETION_REQUEST,
    COMPLETE_ACCOUNT_DELETION,
    CANCEL_ACCOUNT_DELETION,
    WAITLIST,
    WAITLIST_STATS,
    WAITLIST_EXPORT,
    GET_BULK_JOB_STATUS,
    SEND_USER_NOTIFICATION,
    SEND_BULK_NOTIFICATION,
    GET_NOTIFICATION_CAMPAIGNS,
    GET_NOTIFICATION_CAMPAIGN,
    BULK_UPLOAD_PRODUCTS,
    BULK_UPLOAD_BRANDS,
    BULK_UPLOAD_CATEGORIES,
    BULK_UPLOAD_SUBCATEGORIES,
    BULK_UPLOAD_COUPONS,
    BULK_UPLOAD_BANNERS,
    BULK_UPLOAD_GOAL_CATEGORIES,
    BULK_UPLOAD_CUSTOM_GOALS,
    BULK_UPLOAD_FEATURE_VIDEOS,
    BULK_UPLOAD_FAQ,
    BULK_UPLOAD_QUES_AND_ANS,
    BULK_UPLOAD_SPEND_TRACKER,
    EXPORT_PRODUCTS,
    EXPORT_BRANDS,
    EXPORT_CATEGORIES,
    EXPORT_SUBCATEGORIES,
    EXPORT_COUPONS,
    EXPORT_BANNERS,
    EXPORT_GOAL_CATEGORIES,
    EXPORT_CUSTOM_GOALS,
    EXPORT_FEATURE_VIDEOS,
    EXPORT_FAQ,
    EXPORT_QUES_AND_ANS,
    EXPORT_SPEND_TRACKER,
    ANALYTICS_OVERVIEW,
    ANALYTICS_USERS,
    ANALYTICS_GOALS,
    ANALYTICS_PURCHASES,
    ANALYTICS_SPEND_TRACKER,
    ANALYTICS_SUPPORT,
    ASSISTANT_INSIGHTS,
    ASSISTANT_ANSWERS,
    ASSISTANT_ADD_ANSWER,
    ASSISTANT_QUESTIONS,
    GET_BLOG_CATEGORY,
    ADD_BLOG_CATEGORY,
    EDIT_BLOG_CATEGORY,
    DELETE_BLOG_CATEGORY,
    ACTIVE_BLOG_CATEGORY,
    GET_BLOG_SUBCATEGORY,
    ADD_BLOG_SUBCATEGORY,
    EDIT_BLOG_SUBCATEGORY,
    DELETE_BLOG_SUBCATEGORY,
    GET_BLOG_POSTS,
    GET_BLOG_POST,
    ADD_BLOG_POST,
    EDIT_BLOG_POST,
    DELETE_BLOG_POST,
    ACTIVE_BLOG_POST,
    UPLOAD_BLOG_POST_IMAGE,
    GET_BLOG_COMMENTS,
    MODERATE_BLOG_COMMENT,
    DELETE_BLOG_COMMENT,
    MY_ACCESS,
    ROLES,
    PERMISSION_CATALOG,
} from "./ApiEndPoint";

/**
 * --------------------------
 * Brand Products
 * --------------------------
 */

export async function getBrand(page, limit) {
    const res = await axiosInstance.get(
        `${GET_BRANDS}?page=${page - 1}&limit=${limit}`
    );
    return res;
}

export async function addBrand(data) {
    const res = await axiosInstance.post(ADD_BRANDS, data);
    return res;
}

export async function deleteBrand(brandId) {
    const res = await axiosInstance.delete(`${DELETE_BRANDS}/${brandId}`);
    return res;
}

export async function activeBrand(brandid, status) {
    const url = `${ACTIVE_BRANDS}?id=${brandid}&status=${status}`;
    const res = await axiosInstance.put(url);
    return res;
}

export async function editBrand(payload) {
    return axiosInstance.put(EDIT_BRANDS, payload);
}

/**
 * --------------------------
 * Products Category / SubCategory
 * --------------------------
 */

export async function getCategories(page, limit) {
    const res = await axiosInstance.get(
        `${GET_CATEGORY}?page=${page}&limit=${limit}`
    );
    return res;
}

export async function addCategory(data) {
    const res = await axiosInstance.post(ADD_CATEGORY, data);
    return res;
}

export async function deleteCategory(brandId) {
    const res = await axiosInstance.delete(`${DELETE_CATEGORY}/${brandId}`);
    return res;
}

export async function activeCategory(brandid, status) {
    const url = `${ACTIVE_CATEGORY}?id=${brandid}&status=${status}`;
    const res = await axiosInstance.put(url);
    return res;
}

export async function editCategory(payload) {
    return axiosInstance.put(EDIT_CATEGORY, payload);
}

// Sub
export async function getSubCategories(page, limit, id) {
    const res = await axiosInstance.get(
        `${GET_SUBCATEGORY}?page=${page - 1}&limit=${limit}&categoryId=${id}`
    );
    return res;
}

export async function addSubCategory(data) {
    const res = await axiosInstance.post(ADD_SUBCATEGORY, data);
    return res;
}

export async function deleteSubCategory(brandId) {
    const res = await axiosInstance.delete(`${DELETE_SUBCATEGORY}/${brandId}`);
    return res;
}

export async function activeSubCategory(brandid, status) {
    const url = `${ACTIVE_SUBCATEGORY}?id=${brandid}&status=${status}`;
    const res = await axiosInstance.put(url);
    return res;
}

export async function updateSubCategory(status) {
    const res = await axiosInstance.put(UPDATE_SUBCATEGORY, status);
    return res;
}

/**
 * --------------------------
 * PRODUCTS API
 * --------------------------
 */

export async function getProduct(page, limit) {
    const res = await axiosInstance.get(
        `${GET_PRODUCTS}?page=${page}&limit=${limit}`
    );
    return res;
}

export async function getProductById(productId) {
    const res = await axiosInstance.get(
        `${GET_PRODUCT_BY_ID}/${productId}`
    );
    return res;
}

export async function addProduct(data) {
    const res = await axiosInstance.post(ADD_PRODUCTS, data);
    return res;
}

export async function deleteProduct(brandId) {
    const res = await axiosInstance.delete(`${DELETE_PRODUCTS}/${brandId}`);
    return res;
}

export async function activeProducts(brandid, status) {
    const url = `${ACTIVE_PRODUCTS}?id=${brandid}&status=${status}`;
    const res = await axiosInstance.put(url);
    return res;
}

export async function updateProductPrice(productId, payload) {
    const url = `${UPDATE_PRODUCT_PRICE}/${productId}`;
    const res = await axiosInstance.put(url, payload);
    return res;
}

export async function updateProductAddInfo(productId, payload) {
    const url = `${UPDATE_ADDITIONAL_INFO_PRODUCT}/${productId}`;
    const res = await axiosInstance.put(url, payload);
    return res;
}

export async function updateProductInfo(productId, payload) {
    const url = `${UPDATE_INFO_PRODUCT}/${productId}`;
    const res = await axiosInstance.put(url, payload);
    return res;
}

export async function updateProductDetails(productId, payload) {
    const url = `${UPDATE_PRODUCT_DETAILS}/${productId}`;
    const res = await axiosInstance.put(url, payload);
    return res;
}

export async function updateProductDoc(productId, payload) {
    const url = `${UPDATE_PRODUCT_DOC}/${productId}`;
    const res = await axiosInstance.put(url, payload);
    return res;
}

export async function updateProductAddDetails(productId, payload) {
    const url = `${UPDATE_PRODUCT_ADDITION_DETAILS}/${productId}`;
    const res = await axiosInstance.put(url, payload);
    return res;
}

/**
 * --------------------------
 * Spend Tracker
 * --------------------------
 */

export async function getSpendTracker(page, limit) {
    const res = await axiosInstance.get(
        `${GET_SPEND_TRACKER}?page=${page}&limit=${limit}`
    );
    return res;
}

export async function addSpendTracker(data) {
    const res = await axiosInstance.post(ADD_SPEND_TRACKER, data);
    return res;
}

export async function activeSpendTracker(trackerId, status) {
    const url = `${ACTIVE_SPEND_TRACKER}?id=${trackerId}&status=${status}`;
    const res = await axiosInstance.put(url);
    return res;
}

export async function deleteSpendTracker(trackerId) {
    const res = await axiosInstance.delete(
        `${DELETE_SPEND_TRACKER}?id=${trackerId}`
    );
    return res;
}

export async function UpdateSpendTracker(data) {
    const res = await axiosInstance.put(UPDATE_SPEND_TRACKER, data);
    return res;
}

// faq section

export async function addFaqSection(payload) {
    return axiosInstance.post(ADD_FAQ_SECTION, payload);
}
export async function getFaqSection(page, limit) {
    const res = await axiosInstance.get(
        `${GET_FAQ_SECTION}?page=${page}&limit=${limit}`
    );
    return res;
}

export async function activeFaqStatus(faqId, status) {
    const url = `${ACTIVE_FAQ_SECTION}?id=${faqId}&status=${status}`;
    const res = await axiosInstance.put(url);
    return res;
}

export async function deleteFaq(faqId) {
    const res = await axiosInstance.delete(`${DELETE_FAQ_SECTION}?id=${faqId}`);
    return res;
}

export async function UpdateFaq(data) {
    const res = await axiosInstance.put(EDIT_FAQ_SECTION, data);
    return res;
}

// A feature video can carry its reel's MP4 (up to 30 MB), so adding and editing one never
// time out, and the page can pass onUploadProgress to show how far the upload got.
const videoUploadConfig = ({ onUploadProgress } = {}) => ({
    timeout: 0,
    ...(onUploadProgress ? { onUploadProgress } : {}),
});

export async function addVideoInsight(payload, options) {
    return axiosInstance.post(
        ADD_VIDEO_INSIGHT,
        payload,
        videoUploadConfig(options)
    );
}

export async function getVideoInsight(page, limit) {
    const res = await axiosInstance.get(
        `${GET_VIDEO_INSIGHT}?page=${page}&limit=${limit}`
    );
    return res;
}

export async function activeVideoInsight(InsightId, status) {
    const url = `${ACTIVE_VIDEO_INSIGHT}?id=${InsightId}&status=${status}`;
    const res = await axiosInstance.put(url);
    return res;
}

export async function deleteVideoInsight(InsightId) {
    const res = await axiosInstance.delete(
        `${DELETE_VIDEO_INSIGHT}?id=${InsightId}`
    );
    return res;
}

export async function UpdateVideoInsight(data, options) {
    const res = await axiosInstance.put(
        EDIT_VIDEO_INSIGHT,
        data,
        videoUploadConfig(options)
    );
    return res;
}

/**
 * --------------------------
 * Banner
 * --------------------------
 */

export async function getBanners(page, limit) {
    const res = await axiosInstance.get(
        `${GET_BANNERS}?page=${page}&limit=${limit}`
    );
    return res;
}

export async function addBanner(data) {
    const res = await axiosInstance.post(ADD_BANNER, data);
    return res;
}

export async function deleteBanner(bannerId) {
    const res = await axiosInstance.delete(`${DELETE_BANNER}/${bannerId}`);
    return res;
}

export async function activeBanner(bannerId, status) {
    const url = `${ACTIVE_BANNER}?id=${bannerId}&status=${status}`;
    const res = await axiosInstance.put(url);
    return res;
}

export async function EditBanner(data) {
    const res = await axiosInstance.put(EDIT_BANNER, data);
    return res;
}

/**
 * --------------------------
 * Coupon
 * --------------------------
 */

export async function getCoupons(page, limit) {
    const res = await axiosInstance.get(
        `${GET_COUPON}?page=${page}&limit=${limit}`
    );
    return res;
}

export async function addCoupon(data) {
    const res = await axiosInstance.post(ADD_COUPON, data);
    return res;
}

export async function deleteCoupon(CouponId) {
    const res = await axiosInstance.delete(`${DELETE_COUPON}/${CouponId}`);
    return res;
}

export async function activeCoupon(CouponId, status) {
    const url = `${ACTIVE_COUPON}?id=${CouponId}&status=${status}`;
    const res = await axiosInstance.put(url);
    return res;
}

export async function updateCoupon(data) {
    const res = await axiosInstance.put(EDIT_COUPON, data);
    return res;
}

// Custom Goal

export async function getCustomGoals(page, limit) {
    const res = await axiosInstance.get(
        `${GET_CUSTOM_GOAL}?page=${page}&limit=${limit}`
    );
    return res;
}

export async function addCustomGoal(data) {
    const res = await axiosInstance.post(ADD_CUSTOM_GOAL, data);
    return res;
}

export async function deleteCustomGoal(CouponId) {
    const res = await axiosInstance.delete(`${DELETE_CUSTOM_GOAL}?id=${CouponId}`);
    return res;
}

export async function activeCustomGoal(CouponId, status) {
    const url = `${ACTIVE_CUSTOM_GOAL}?id=${CouponId}&status=${status}`;
    const res = await axiosInstance.put(url);
    return res;
}

export async function updateCustomGoal(data) {
    const res = await axiosInstance.put(EDIT_CUSTOM_GOAL, data);
    return res;
}

/**
 * --------------------------
 * Goal Category
 * --------------------------
 */

export async function getGoalCategory(page, limit) {
    const res = await axiosInstance.get(
        `${GET_GOAL_CATEGORY}?page=${page}&limit=${limit}`
    );
    return res;
}

export async function addGoalCategory(data) {
    const res = await axiosInstance.post(ADD_GOAL_CATEGORY, data);
    return res;
}

export async function deleteGoalCategory(CouponId) {
    const res = await axiosInstance.delete(
        `${DELETE_GOAL_CATEGORY}/${CouponId}`
    );
    return res;
}

export async function activeGoalCategory(CouponId, status) {
    const url = `${ACTIVE_GOAL_CATEGORY}?id=${CouponId}&status=${status}`;
    const res = await axiosInstance.put(url);
    return res;
}

export async function updateGoalCategory(data) {
    const res = await axiosInstance.put(EDIT_GOAL_CATEGORY, data);
    return res;
}

// Boarding System

export async function getBoarding(page, limit) {
    const res = await axiosInstance.get(
        `${GET_BOARDING}?page=${page}&limit=${limit}`
    );
    return res;
}

export async function addBoarding(data) {
    const res = await axiosInstance.put(UPDATE_BOARDING, data);
    return res;
}

export async function deleteBoarding(BoardingId) {
    const res = await axiosInstance.delete(
        `${DELETE_BOARDING}?id=${BoardingId}`
    );
    return res;
}

export async function activeBoarding(CouponId, status) {
    const url = `${ACTIVE_BOARDING}?id=${CouponId}&status=${status}`;
    const res = await axiosInstance.put(url);
    return res;
}

export async function UpdateBoardingSystem(data) {
    const res = await axiosInstance.put(EDIT_BOARDING, data);
    return res;
}

function toQueryString(params = {}) {
    const usp = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            usp.append(key, value);
        }
    });
    const qs = usp.toString();
    return qs ? `?${qs}` : "";
}

/**
 * --------------------------
 * Admin Management
 * --------------------------
 */

export async function getAdmins({ page = 1, limit = 10, search, isActive, roleId } = {}) {
    const qs = toQueryString({ page, limit, search, isActive, roleId });
    const res = await axiosInstance.get(`${GET_ADMINS}${qs}`);
    return res;
}

export async function updateAdmin(payload) {
    const res = await axiosInstance.put(UPDATE_ADMIN, payload);
    return res;
}

export async function deleteAdmin(id) {
    const res = await axiosInstance.delete(`${DELETE_ADMIN}?id=${id}`);
    return res;
}

export async function getMyProfile() {
    const res = await axiosInstance.get(ADMIN_PROFILE);
    return res;
}

export async function updateMyProfile(payload) {
    const res = await axiosInstance.put(ADMIN_PROFILE, payload);
    return res;
}

/**
 * --------------------------
 * Roles & Permissions
 * --------------------------
 */

// The signed-in admin's own role + permissions ({ role, isRoot, permissions }).
export async function getMyAccess() {
    return axiosInstance.get(MY_ACCESS);
}

export async function getPermissionCatalog() {
    return axiosInstance.get(PERMISSION_CATALOG);
}

export async function getRoles() {
    return axiosInstance.get(ROLES);
}

export async function createRole(payload) {
    return axiosInstance.post(ROLES, payload);
}

export async function updateRole(payload) {
    return axiosInstance.put(ROLES, payload);
}

export async function deleteRole(id) {
    return axiosInstance.delete(`${ROLES}?id=${id}`);
}

/**
 * --------------------------
 * App Users (roster + activity)
 * --------------------------
 */

export async function getUsersList({
    page = 1,
    limit = 10,
    search,
    isActive,
    isVkyc,
} = {}) {
    const qs = toQueryString({ page, limit, search, isActive, isVkyc });
    const res = await axiosInstance.get(`${GET_USERS}${qs}`);
    return res;
}

export async function getUserActivity(userId) {
    const qs = toQueryString({ userId });
    const res = await axiosInstance.get(`${GET_USER_ACTIVITY}${qs}`);
    return res;
}

/**
 * --------------------------
 * Account deletion requests
 * --------------------------
 */

export async function getAccountDeletionRequests({ page = 1, limit = 20, status = "pending", search } = {}) {
    const qs = toQueryString({ page, limit, status, search });
    return axiosInstance.get(`${GET_ACCOUNT_DELETION_REQUESTS}${qs}`);
}

export async function getAccountDeletionRequest(id) {
    const qs = toQueryString({ id });
    return axiosInstance.get(`${GET_ACCOUNT_DELETION_REQUEST}${qs}`);
}

/** Soft-deletes the account. `balanceSettled` confirms a leftover wallet balance was refunded. */
export async function completeAccountDeletion(id, { note, balanceSettled } = {}) {
    return axiosInstance.post(COMPLETE_ACCOUNT_DELETION, { id, note, balanceSettled });
}

/** The account comes back: sign-in works again and the card is unlocked. */
export async function cancelAccountDeletion(id, { note } = {}) {
    return axiosInstance.post(CANCEL_ACCOUNT_DELETION, { id, note });
}

/**
 * --------------------------
 * Launch waitlist (website sign-ups). from / to are "YYYY-MM-DD" (IST, inclusive).
 * --------------------------
 */

export async function getWaitlist({ page, limit, search, platform, status, interest, from, to } = {}) {
    const qs = toQueryString({ page, limit, search, platform, status, interest, from, to });
    return axiosInstance.get(`${WAITLIST}${qs}`);
}

export async function getWaitlistStats() {
    return axiosInstance.get(WAITLIST_STATS);
}

// The CSV file, or JSON { status: false, message } (HTTP 400): fetched as a Blob so the
// auth header goes along (a plain link can't send it).
export async function exportWaitlist({ search, platform, status, interest, from, to } = {}) {
    const qs = toQueryString({ search, platform, status, interest, from, to });
    return axiosInstance.get(`${WAITLIST_EXPORT}${qs}`, { responseType: "blob" });
}

/** { status?: "waiting" | "invited" | "joined", note? } */
export async function updateWaitlistEntry(id, changes) {
    return axiosInstance.patch(`${WAITLIST}/${id}`, changes);
}

/** Erases the person's details for good (a deletion request); the row stays for the counts. */
export async function deleteWaitlistEntry(id) {
    return axiosInstance.delete(`${WAITLIST}/${id}`);
}

/**
 * --------------------------
 * Notifications (push + in-app)
 * --------------------------
 */

// Both endpoints accept an optional `image` File - always sent as
// multipart/form-data (even when there's no image) since the backend's
// upload middleware only populates req.uploadedFiles for multipart requests.
function buildNotificationForm(fields) {
    const form = new FormData();
    Object.entries(fields).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") return;
        form.append(key, value);
    });
    return form;
}

export async function sendUserNotification({
    userId,
    title,
    message,
    route,
    image,
    priority,
    sticky,
    type,
}) {
    const form = buildNotificationForm({
        userId,
        title,
        message,
        route,
        priority,
        sticky,
        type,
    });
    if (image) form.append("image", image);
    const res = await axiosInstance.post(SEND_USER_NOTIFICATION, form);
    return res;
}

export async function sendBulkNotification({
    title,
    message,
    route,
    image,
    priority,
    sticky,
    type,
    isActive,
    isVkyc,
    search,
}) {
    const form = buildNotificationForm({
        title,
        message,
        route,
        priority,
        sticky,
        type,
        isActive,
        isVkyc,
        search,
    });
    if (image) form.append("image", image);
    const res = await axiosInstance.post(SEND_BULK_NOTIFICATION, form);
    return res;
}

export async function getNotificationCampaigns({ page = 1, limit = 10 } = {}) {
    const qs = toQueryString({ page, limit });
    const res = await axiosInstance.get(`${GET_NOTIFICATION_CAMPAIGNS}${qs}`);
    return res;
}

export async function getNotificationCampaign(id) {
    const qs = toQueryString({ id });
    const res = await axiosInstance.get(`${GET_NOTIFICATION_CAMPAIGN}${qs}`);
    return res;
}

/**
 * --------------------------
 * Bulk Import / Export
 * --------------------------
 */

function buildBulkUploadForm(file) {
    const form = new FormData();
    form.append("file", file);
    return form;
}

export async function bulkUploadProducts(file) {
    const res = await axiosInstance.post(
        BULK_UPLOAD_PRODUCTS,
        buildBulkUploadForm(file)
    );
    return res;
}

export async function bulkUploadBrands(file) {
    const res = await axiosInstance.post(
        BULK_UPLOAD_BRANDS,
        buildBulkUploadForm(file)
    );
    return res;
}

export async function bulkUploadCategories(file) {
    const res = await axiosInstance.post(
        BULK_UPLOAD_CATEGORIES,
        buildBulkUploadForm(file)
    );
    return res;
}

export async function bulkUploadSubCategories(file) {
    const res = await axiosInstance.post(
        BULK_UPLOAD_SUBCATEGORIES,
        buildBulkUploadForm(file)
    );
    return res;
}

export async function bulkUploadCoupons(file) {
    const res = await axiosInstance.post(
        BULK_UPLOAD_COUPONS,
        buildBulkUploadForm(file)
    );
    return res;
}

export async function bulkUploadBanners(file) {
    const res = await axiosInstance.post(
        BULK_UPLOAD_BANNERS,
        buildBulkUploadForm(file)
    );
    return res;
}

export async function bulkUploadGoalCategories(file) {
    const res = await axiosInstance.post(
        BULK_UPLOAD_GOAL_CATEGORIES,
        buildBulkUploadForm(file)
    );
    return res;
}

export async function bulkUploadCustomGoals(file) {
    const res = await axiosInstance.post(
        BULK_UPLOAD_CUSTOM_GOALS,
        buildBulkUploadForm(file)
    );
    return res;
}

export async function bulkUploadFeatureVideos(file) {
    const res = await axiosInstance.post(
        BULK_UPLOAD_FEATURE_VIDEOS,
        buildBulkUploadForm(file)
    );
    return res;
}

export async function bulkUploadFaq(file) {
    const res = await axiosInstance.post(
        BULK_UPLOAD_FAQ,
        buildBulkUploadForm(file)
    );
    return res;
}

export async function bulkUploadQuesAndAns(file) {
    const res = await axiosInstance.post(
        BULK_UPLOAD_QUES_AND_ANS,
        buildBulkUploadForm(file)
    );
    return res;
}

export async function bulkUploadSpendTrackerCategories(file) {
    const res = await axiosInstance.post(
        BULK_UPLOAD_SPEND_TRACKER,
        buildBulkUploadForm(file)
    );
    return res;
}

// Exports are queued jobs now (see bulkJobWorker.ts on the backend) - this
// returns { jobId } immediately; poll getBulkJobStatus(jobId) for the
// eventual { fileUrl, format } result instead of expecting a file here.
async function exportEntity(endpoint, { isActive, format = "xlsx" } = {}) {
    const qs = toQueryString({ isActive, format });
    const res = await axiosInstance.get(`${endpoint}${qs}`);
    return res;
}

export async function getBulkJobStatus(id) {
    const qs = toQueryString({ id });
    const res = await axiosInstance.get(`${GET_BULK_JOB_STATUS}${qs}`);
    return res;
}

export const exportProducts = (params) => exportEntity(EXPORT_PRODUCTS, params);
export const exportBrands = (params) => exportEntity(EXPORT_BRANDS, params);
export const exportCategories = (params) =>
    exportEntity(EXPORT_CATEGORIES, params);
export const exportSubCategories = (params) =>
    exportEntity(EXPORT_SUBCATEGORIES, params);
export const exportCoupons = (params) => exportEntity(EXPORT_COUPONS, params);
export const exportBanners = (params) => exportEntity(EXPORT_BANNERS, params);
export const exportGoalCategories = (params) =>
    exportEntity(EXPORT_GOAL_CATEGORIES, params);
export const exportCustomGoals = (params) =>
    exportEntity(EXPORT_CUSTOM_GOALS, params);
export const exportFeatureVideos = (params) =>
    exportEntity(EXPORT_FEATURE_VIDEOS, params);
export const exportFaq = (params) => exportEntity(EXPORT_FAQ, params);
export const exportQuesAndAns = (params) =>
    exportEntity(EXPORT_QUES_AND_ANS, params);
export const exportSpendTrackerCategories = (params) =>
    exportEntity(EXPORT_SPEND_TRACKER, params);

/**
 * --------------------------
 * Analytics
 * --------------------------
 */

export async function getAnalyticsOverview() {
    const res = await axiosInstance.get(ANALYTICS_OVERVIEW);
    return res;
}

export async function getUserAnalytics({ startDate, endDate, groupBy = "day" } = {}) {
    const qs = toQueryString({ startDate, endDate, groupBy });
    const res = await axiosInstance.get(`${ANALYTICS_USERS}${qs}`);
    return res;
}

export async function getGoalAnalytics({ startDate, endDate, groupBy = "day" } = {}) {
    const qs = toQueryString({ startDate, endDate, groupBy });
    const res = await axiosInstance.get(`${ANALYTICS_GOALS}${qs}`);
    return res;
}

export async function getPurchaseAnalytics({ startDate, endDate, groupBy = "day" } = {}) {
    const qs = toQueryString({ startDate, endDate, groupBy });
    const res = await axiosInstance.get(`${ANALYTICS_PURCHASES}${qs}`);
    return res;
}

export async function getSpendTrackerAnalytics({
    startDate,
    endDate,
    groupBy = "day",
} = {}) {
    const qs = toQueryString({ startDate, endDate, groupBy });
    const res = await axiosInstance.get(`${ANALYTICS_SPEND_TRACKER}${qs}`);
    return res;
}

export async function getSupportAnalytics({ startDate, endDate, groupBy = "day" } = {}) {
    const qs = toQueryString({ startDate, endDate, groupBy });
    const res = await axiosInstance.get(`${ANALYTICS_SUPPORT}${qs}`);
    return res;
}

/**
 * --------------------------
 * Assistant insights
 * --------------------------
 */
// days: 7 | 30 | 90. fresh skips the server's 10-minute cache (the page's Refresh button).
export async function getAssistantInsights({ days = 30, fresh = false } = {}) {
    const qs = toQueryString({ days, fresh: fresh ? "true" : undefined });
    return axiosInstance.get(`${ASSISTANT_INSIGHTS}${qs}`);
}
// The answers added from the insights (they're FAQs too), newest first.
export async function getAssistantAnswers() {
    return axiosInstance.get(ASSISTANT_ANSWERS);
}
// { question, answer, alsoAsked: string[] } -> an FAQ the assistant uses right away.
export async function addAssistantAnswer({ question, answer, alsoAsked = [] }) {
    return axiosInstance.post(ASSISTANT_ADD_ANSWER, { question, answer, alsoAsked });
}
// The question bank: { questions, total, counts }. status: open | drafted | answered | dismissed.
export async function getAssistantQuestions({ status = "", page = 1, limit = 20 } = {}) {
    const qs = toQueryString({ status: status || undefined, page, limit });
    return axiosInstance.get(`${ASSISTANT_QUESTIONS}${qs}`);
}
// Approve the drafted answer, optionally edited: it becomes an FAQ the assistant uses for everyone.
export async function approveAssistantQuestion(id, { question, answer } = {}) {
    return axiosInstance.post(`${ASSISTANT_QUESTIONS}/${id}/approve`, { question, answer });
}
export async function redraftAssistantQuestion(id) {
    return axiosInstance.post(`${ASSISTANT_QUESTIONS}/${id}/draft`, {});
}
export async function dismissAssistantQuestion(id) {
    return axiosInstance.post(`${ASSISTANT_QUESTIONS}/${id}/dismiss`, {});
}
export async function reopenAssistantQuestion(id) {
    return axiosInstance.post(`${ASSISTANT_QUESTIONS}/${id}/reopen`, {});
}

/**
 * --------------------------
 * Blog - Category
 * --------------------------
 */
export async function getBlogCategories(page, limit) {
    const res = await axiosInstance.get(`${GET_BLOG_CATEGORY}?page=${page}&limit=${limit}`);
    return res;
}
export async function addBlogCategory(data) {
    const res = await axiosInstance.post(ADD_BLOG_CATEGORY, data);
    return res;
}
export async function updateBlogCategory(data) {
    const res = await axiosInstance.put(EDIT_BLOG_CATEGORY, data);
    return res;
}
export async function deleteBlogCategory(categoryId) {
    const res = await axiosInstance.delete(`${DELETE_BLOG_CATEGORY}/${categoryId}`);
    return res;
}
export async function activeBlogCategory(categoryId, status) {
    const res = await axiosInstance.put(`${ACTIVE_BLOG_CATEGORY}?id=${categoryId}&status=${status}`);
    return res;
}

/**
 * --------------------------
 * Blog - Sub-category
 * --------------------------
 */
export async function getBlogSubCategories(page, limit, categoryId) {
    const qs = toQueryString({ page, limit, categoryId });
    const res = await axiosInstance.get(`${GET_BLOG_SUBCATEGORY}${qs}`);
    return res;
}
export async function addBlogSubCategory(data) {
    const res = await axiosInstance.post(ADD_BLOG_SUBCATEGORY, data);
    return res;
}
export async function updateBlogSubCategory(data) {
    const res = await axiosInstance.put(EDIT_BLOG_SUBCATEGORY, data);
    return res;
}
export async function deleteBlogSubCategory(subCategoryId) {
    const res = await axiosInstance.delete(`${DELETE_BLOG_SUBCATEGORY}/${subCategoryId}`);
    return res;
}

/**
 * --------------------------
 * Blog - Post
 * --------------------------
 */
export async function getBlogPosts({ page, limit, status, category, search } = {}) {
    const qs = toQueryString({ page, limit, status, category, search });
    const res = await axiosInstance.get(`${GET_BLOG_POSTS}${qs}`);
    return res;
}
export async function getBlogPost(postId) {
    const res = await axiosInstance.get(`${GET_BLOG_POST}/${postId}`);
    return res;
}
export async function addBlogPost(data) {
    const res = await axiosInstance.post(ADD_BLOG_POST, data);
    return res;
}
export async function updateBlogPost(data) {
    const res = await axiosInstance.put(EDIT_BLOG_POST, data);
    return res;
}
export async function deleteBlogPost(postId) {
    const res = await axiosInstance.delete(`${DELETE_BLOG_POST}/${postId}`);
    return res;
}
export async function activeBlogPost(postId, status) {
    const res = await axiosInstance.put(`${ACTIVE_BLOG_POST}?id=${postId}&status=${status}`);
    return res;
}
// Used by the post editor's rich text image toolbar button - uploads a single image and
// returns its CDN URL to insert inline, separate from the post's own cover/OG images.
export async function uploadBlogPostImage(file) {
    const form = new FormData();
    form.append("image", file);
    const res = await axiosInstance.post(UPLOAD_BLOG_POST_IMAGE, form);
    return res;
}

/**
 * --------------------------
 * Blog - Comments
 * --------------------------
 */
export async function getBlogComments({ page, limit, postId, status } = {}) {
    const qs = toQueryString({ page, limit, postId, status });
    const res = await axiosInstance.get(`${GET_BLOG_COMMENTS}${qs}`);
    return res;
}
export async function moderateBlogComment(id, status) {
    const res = await axiosInstance.put(MODERATE_BLOG_COMMENT, { id, status });
    return res;
}
export async function deleteBlogComment(commentId) {
    const res = await axiosInstance.delete(`${DELETE_BLOG_COMMENT}/${commentId}`);
    return res;
}

/**
 * --------------------------
 * Rewards - coupons (Coupontools) and scratch card rules
 * --------------------------
 */
export async function getRewardStats() {
    return axiosInstance.get(REWARDS_STATS);
}
export async function getRewardCampaigns() {
    return axiosInstance.get(REWARDS_CAMPAIGNS);
}
export async function addRewardOffers(campaignIds) {
    return axiosInstance.post(REWARDS_ADD_OFFERS, { campaignIds });
}
/** Our own prize: { kind: "coins", coins } or { kind: "voucher_discount", voucher: { brandCode, pct } }. */
export async function addOwnRewardPrize(data) {
    return axiosInstance.post(REWARDS_ADD_OWN_PRIZE, data);
}
export async function getRewardOffers({ page, limit, search } = {}) {
    return axiosInstance.get(`${REWARDS_OFFERS}${toQueryString({ page, limit, search })}`);
}
export async function editRewardOffer(offerId, data) {
    return axiosInstance.put(`${REWARDS_EDIT_OFFER}/${offerId}`, data);
}
export async function syncRewardOffers() {
    return axiosInstance.put(REWARDS_SYNC_OFFERS);
}
export async function deleteRewardOffer(offerId) {
    return axiosInstance.delete(`${REWARDS_DELETE_OFFER}/${offerId}`);
}
export async function getIssuedRewardCoupons({ page, limit, status, source, offerId, userId } = {}) {
    const qs = toQueryString({ page, limit, status, source, offerId, userId });
    return axiosInstance.get(`${REWARDS_ISSUED_COUPONS}${qs}`);
}
export async function voidRewardCoupon(couponId) {
    return axiosInstance.put(`${REWARDS_VOID_COUPON}/${couponId}`);
}
export async function retryRewardCoupon(couponId) {
    return axiosInstance.put(`${REWARDS_RETRY_COUPON}/${couponId}`);
}
export async function getRewardRuleEvents() {
    return axiosInstance.get(REWARDS_RULE_EVENTS);
}
export async function getRewardRules({ page, limit, search } = {}) {
    return axiosInstance.get(`${REWARDS_RULES}${toQueryString({ page, limit, search })}`);
}
export async function addRewardRule(data) {
    return axiosInstance.post(REWARDS_ADD_RULE, data);
}
export async function editRewardRule(ruleId, data) {
    return axiosInstance.put(`${REWARDS_EDIT_RULE}/${ruleId}`, data);
}
export async function deleteRewardRule(ruleId) {
    return axiosInstance.delete(`${REWARDS_DELETE_RULE}/${ruleId}`);
}
export async function getRewardScratchCards({ page, limit, status, ruleId, userId } = {}) {
    const qs = toQueryString({ page, limit, status, ruleId, userId });
    return axiosInstance.get(`${REWARDS_SCRATCH_CARDS}${qs}`);
}

/**
 * --------------------------
 * Refer & Earn - referrals (who referred whom)
 * --------------------------
 */

/**
 * Newest first. code: the 8-character code (any case); phone: 10 digits, matched as inviter
 * or friend; status: "joined" | "rewarded" | "reversed" | "". Phones come back masked.
 * data: { referrals: [...], total }
 */
export async function getReferrals({ page, limit, code, phone, status } = {}) {
    const qs = toQueryString({ page, limit, code, phone, status });
    return axiosInstance.get(`${REFERRALS_ADMIN}${qs}`);
}

/**
 * Stops the referral counting and takes back the coins it gave (never below 0).
 * reason: 3-300 characters. data: { id, wasStatus, taken: { friend, inviter } }
 */
export async function reverseReferral(id, reason) {
    return axiosInstance.post(`${REFERRALS_ADMIN}/${encodeURIComponent(id)}/reverse`, { reason });
}

/**
 * --------------------------
 * Recharge & Bills - convenience fee rules, settings, orders and invoices
 * --------------------------
 */
export async function getBillpayChargeRules() {
    return axiosInstance.get(BILLPAY_CHARGE_RULES);
}
export async function addBillpayChargeRule(data) {
    return axiosInstance.post(BILLPAY_ADD_CHARGE_RULE, data);
}
export async function editBillpayChargeRule(ruleId, data) {
    return axiosInstance.put(`${BILLPAY_EDIT_CHARGE_RULE}/${ruleId}`, data);
}
export async function activeBillpayChargeRule(ruleId, isActive) {
    return axiosInstance.put(`${BILLPAY_ACTIVE_CHARGE_RULE}/${ruleId}`, { isActive });
}
export async function deleteBillpayChargeRule(ruleId) {
    return axiosInstance.delete(`${BILLPAY_DELETE_CHARGE_RULE}/${ruleId}`);
}
// The fee a payment like this would pay now: { rule, amount, fee, feeGst, total }.
export async function getBillpayChargePreview({ kind, service, category, operator, billerId, amount } = {}) {
    const qs = toQueryString({ kind, service, category, operator, billerId, amount });
    return axiosInstance.get(`${BILLPAY_CHARGE_PREVIEW}${qs}`);
}
// ---- Gift-voucher offers (% off per brand)

/** Every brand in the Vouchagram catalogue with its offer, plus the cap. */
export async function getVoucherOffers({ q, filter } = {}) {
    const qs = toQueryString({ q, filter });
    return axiosInstance.get(`${VOUCHER_OFFERS}${qs}`);
}

/** Sets a brand's % off (0 or active false clears it), and optionally its margin and keep %. */
export async function editVoucherOffer(brandCode, { discountPct, active, marginPct, keepPct }) {
    return axiosInstance.put(`${VOUCHER_EDIT_OFFER}/${encodeURIComponent(brandCode)}`, {
        discountPct,
        active,
        ...(marginPct !== undefined ? { marginPct } : {}),
        ...(keepPct !== undefined ? { keepPct } : {}),
    });
}

export async function getBillpaySettings() {
    return axiosInstance.get(BILLPAY_SETTINGS);
}
export async function editBillpaySettings(data) {
    return axiosInstance.put(BILLPAY_EDIT_SETTINGS, data);
}
// Asks KwikAPI for our balance now (one of the day's 48 balance checks).
export async function checkBillpayKwikBalance() {
    return axiosInstance.get(BILLPAY_KWIK_BALANCE);
}
export async function getBillpayOrders({ page, limit, kind, state, userId, q, from, to } = {}) {
    const qs = toQueryString({ page, limit, kind, state, userId, q, from, to });
    return axiosInstance.get(`${BILLPAY_ORDERS}${qs}`);
}
export async function getBillpayOrder(orderId) {
    return axiosInstance.get(`${BILLPAY_ORDER}/${orderId}`);
}
/**
 * Sends a refund again. After a refund that got no clear answer the first call fails and
 * asks for the user's ToPay passbook to be checked; send confirmNotRefunded: true once it has.
 */
export async function retryBillpayRefund(orderId, { confirmNotRefunded, note } = {}) {
    return axiosInstance.put(`${BILLPAY_RETRY_REFUND}/${orderId}`, { confirmNotRefunded, note });
}
/** Closes an order in review: outcome "success" | "refund" | "refunded" | "failed", with a 5-500 character note. */
export async function completeBillpayOrderReview(orderId, { outcome, note } = {}) {
    return axiosInstance.put(`${BILLPAY_COMPLETE_REVIEW}/${orderId}`, { outcome, note });
}
/** Emails the order's invoice again: { emailedTo }. */
export async function sendBillpayInvoice(orderId) {
    return axiosInstance.post(`${BILLPAY_SEND_INVOICE}/${orderId}`);
}
export async function getBillpayStats({ from, to } = {}) {
    return axiosInstance.get(`${BILLPAY_STATS}${toQueryString({ from, to })}`);
}
// Invoice register for the accounts team. from / to are "YYYY-MM-DD" (IST, inclusive).
export async function getBillpayInvoices({ from, to, kind, q, archived, emailed, page, limit } = {}) {
    const qs = toQueryString({ from, to, kind, q, archived, emailed, page, limit });
    return axiosInstance.get(`${BILLPAY_INVOICES}${qs}`);
}
export async function getBillpayInvoiceSummary({ from, to } = {}) {
    return axiosInstance.get(`${BILLPAY_INVOICE_SUMMARY}${toQueryString({ from, to })}`);
}
// The two file routes answer with the file, or JSON { status: false, message } (HTTP
// 400/404): fetched as a Blob so the auth header goes along (a plain link can't send it).
export async function downloadBillpayInvoice(orderId) {
    return axiosInstance.get(`${BILLPAY_DOWNLOAD_INVOICE}/${orderId}`, { responseType: "blob" });
}
export async function exportBillpayInvoices({ from, to, kind, format = "csv" } = {}) {
    const qs = toQueryString({ from, to, kind, format });
    return axiosInstance.get(`${BILLPAY_EXPORT_INVOICES}${qs}`, { responseType: "blob" });
}

/**
 * --------------------------
 * Messaging - services, routing, SMS (DLT) and WhatsApp templates, test sends, message log
 * (backend/docs/MESSAGING.md, "CMS API")
 * --------------------------
 */

/** { settings, status, channels, categories }. */
export async function getMessagingSettings() {
    return axiosInstance.get(MESSAGING_SETTINGS);
}
/** Any part of `settings`, e.g. { services: { sms: { enabled: false } } }. Answers like getMessagingSettings. */
export async function editMessagingSettings(data) {
    return axiosInstance.put(MESSAGING_EDIT_SETTINGS, data);
}
/** { defaultRouting, otp, templates: [one row per notification] }. */
export async function getMessagingRouting() {
    return axiosInstance.get(MESSAGING_ROUTING);
}
/** { mode: "default" } or { mode: "custom", channels: ["push", "email"] }. Answers with the notification's row. */
export async function editMessagingRouting(key, data) {
    return axiosInstance.put(`${MESSAGING_EDIT_ROUTING}/${encodeURIComponent(key)}`, data);
}
/** { senderId, entityId, templates }. */
export async function getMessagingSmsTemplates() {
    return axiosInstance.get(MESSAGING_SMS_TEMPLATES);
}
/** { text, dltTemplateId }; { text: "" } removes the template. Answers with the row. */
export async function editMessagingSmsTemplate(key, data) {
    return axiosInstance.put(`${MESSAGING_EDIT_SMS_TEMPLATE}/${encodeURIComponent(key)}`, data);
}
/** { syncedAt, configured, templates }. */
export async function getMessagingWhatsAppTemplates() {
    return axiosInstance.get(MESSAGING_WHATSAPP_TEMPLATES);
}
/** Reads the statuses from Meta now. Answers like getMessagingWhatsAppTemplates (400 when WhatsApp isn't set up). */
export async function syncMessagingWhatsAppTemplates() {
    return axiosInstance.post(MESSAGING_SYNC_WHATSAPP_TEMPLATES);
}
/**
 * A template's banner: { en, hi } files (JPEG or PNG, at most 1 MB) replace it (multipart),
 * { reset: ["en", "hi"] } goes back to the default. Answers with the template's row.
 */
export async function editMessagingWhatsAppBanner(name, { en, hi, reset } = {}) {
    const url = `${MESSAGING_EDIT_WHATSAPP_BANNER}/${encodeURIComponent(name)}`;
    if (reset) return axiosInstance.put(url, { reset });
    const form = new FormData();
    if (en) form.append("en", en);
    if (hi) form.append("hi", hi);
    return axiosInstance.put(url, form);
}
/**
 * Asks Meta whether the WhatsApp settings fit together: { checkedAt, ok, checks: [{ key, label,
 * ok, detail }] }, each failed check saying what to fix (an app ID in WHATSAPP_WABA_ID, a system
 * user without the account, a webhook not set up...).
 */
export async function checkMessagingWhatsApp() {
    return axiosInstance.get(MESSAGING_CHECK_WHATSAPP);
}
/**
 * The sample version of a message, without consent checks (at most 20 per admin an hour):
 * { channel: "whatsapp", template, to, language }, { channel: "sms", key, to } or
 * { channel: "email", key, to, language }. data: { status: "sent" | "failed", detail }.
 */
export async function sendMessagingTest(data) {
    return axiosInstance.post(MESSAGING_SEND_TEST, data);
}
/** data: { items, total, page, limit, summary } - summary covers the last 24 hours. */
export async function getMessagingLog({ channel, status, purpose, template, page, limit } = {}) {
    const qs = toQueryString({ channel, status, purpose, template, page, limit });
    return axiosInstance.get(`${MESSAGING_MESSAGE_LOG}${qs}`);
}

/**
 * --------------------------
 * WhatsApp inbox and campaigns (backend/docs/WHATSAPP_INBOX.md, "CMS API")
 * --------------------------
 */

/** { counts: { open, unread, mine, unassigned }, whatsappOn, inboxReplies, followUp: { name, approved } }. */
export async function getWhatsAppInboxSummary() {
    return axiosInstance.get(MESSAGING_INBOX_SUMMARY);
}
/** status open | closed | all, filter unread | mine | unassigned, q (a name or 4+ digits). { items, total, page, limit }. */
export async function getWhatsAppConversations({ status, filter, q, page, limit } = {}) {
    const qs = toQueryString({ status, filter, q, page, limit });
    return axiosInstance.get(`${MESSAGING_CONVERSATIONS}${qs}`);
}
/** { conversation, items (oldest first), hasMore }; `before` (ISO) pages back. Doesn't mark it read. */
export async function getWhatsAppConversation(id, { before, limit } = {}) {
    const qs = toQueryString({ before, limit });
    return axiosInstance.get(`${MESSAGING_CONVERSATION}/${encodeURIComponent(id)}${qs}`);
}
/** { text } inside the 24-hour window, or { template: "support_follow_up" }. data: { message, conversation }. */
export async function sendWhatsAppReply(id, data) {
    return axiosInstance.post(`${MESSAGING_SEND_REPLY}/${encodeURIComponent(id)}`, data);
}
/** Any of { read: true }, { status: "open" | "closed" }, { assign: "me" | "none" }. data: { conversation }. */
export async function editWhatsAppConversation(id, data) {
    return axiosInstance.put(`${MESSAGING_EDIT_CONVERSATION}/${encodeURIComponent(id)}`, data);
}
/** The file itself as a blob (404: Meta no longer has it, 413: over 25 MB; errors come as JSON). */
export async function getWhatsAppInboxMedia(messageId) {
    return axiosInstance.get(`${MESSAGING_INBOX_MEDIA}/${encodeURIComponent(messageId)}`, { responseType: "blob" });
}
/** { templates: [{ name, when, approved, status, imageUrl, body, footer, buttons, fields }], hours, caps, costPerMessage }. */
export async function getWhatsAppCampaignTemplates() {
    return axiosInstance.get(MESSAGING_CAMPAIGN_TEMPLATES);
}
/**
 * { template, values, audience: { language: "all" | "en" | "hi", limit } }. data: { audience, approved,
 * hindiGetsEnglish, messages: { en, hi }, estimatedCost, problems }.
 */
export async function previewWhatsAppCampaign(data) {
    return axiosInstance.post(MESSAGING_PREVIEW_CAMPAIGN, data);
}
/** { template, values, to, language }: the real message to one number. data: { status: "sent" | "failed", detail }. */
export async function testWhatsAppCampaign(data) {
    return axiosInstance.post(MESSAGING_TEST_CAMPAIGN, data);
}
/** { key, name, template, values, audience, startAt (null = now) }. data: { campaign }. */
export async function createWhatsAppCampaign(data) {
    return axiosInstance.post(MESSAGING_CREATE_CAMPAIGN, data);
}
/** { items, total, page, limit }, newest first. */
export async function getWhatsAppCampaigns({ page, limit } = {}) {
    const qs = toQueryString({ page, limit });
    return axiosInstance.get(`${MESSAGING_CAMPAIGNS}${qs}`);
}
/** { campaign }, with live delivery figures. */
export async function getWhatsAppCampaign(id) {
    return axiosInstance.get(`${MESSAGING_CAMPAIGN}/${encodeURIComponent(id)}`);
}
/** Stops a scheduled, running or waiting campaign. data: { campaign }. */
export async function stopWhatsAppCampaign(id) {
    return axiosInstance.put(`${MESSAGING_STOP_CAMPAIGN}/${encodeURIComponent(id)}`);
}
